import ObjectPath from './object-path'

function componentsOnScreenWithTag(tag) {
    return function ({ path, screenId, screens }) {
        //TODO использовать import { matchPropertyPath } from './object-path' когда уйдем от легаси
        if (ObjectPath.matchPropertyPath(path, 'router.[screens HashList]./^[0-9a-z]+$/.components') && screens) {
            const r = screens.find(s => s.hashlistId === screenId)
            if (r && r.tags) {
                return r.tags.indexOf(tag) >= 0
            }
        }
        return false
    }
}

function anyComponentOnScreen() {
    return function ({ path, screenId, screens }) {
        //TODO использовать import { matchPropertyPath } from './object-path' когда уйдем от легаси
        return ObjectPath.matchPropertyPath(path, 'router.[screens HashList]./^[0-9a-z]+$/.components')
    }
}

export default {
    componentsOnScreenWithTag,
    anyComponentOnScreen,
}
